// Top-level routing file for all the single-page app stuff we have
import React from 'react'
import { Router as ReactRouter, Route, browserHistory, applyRouterMiddleware } from 'react-router'
import { useScroll } from 'react-router-scroll'

// import stuff that follows the SPA convention
import { routes as rrRoutes } from 'features/ride_reports'
import { routes as reportsPageRoutes } from 'features/ride_reports/ReportsPage'
import { routes as goalsRoutes } from 'features/goals'
import { routes as trouteShowRoutes } from 'features/troute_show'
import { routes as styleguideRoutes } from 'features/styleguide'
import { routes as adminRoutes } from 'features/admin'
import { routes as homepageRoutes } from 'features/homepage'
import { routes as notificationsRoutes } from 'features/notifications'
import { routes as connectIqRoutes } from 'features/connect_iq'
import { routes as experiencesRoutes } from 'features/experiences'
import { routes as paymentsRoutes } from 'features/payments'
import { routes as usersRoutes } from 'features/users'
import { routes as organizationsRoutes } from 'features/organizations'
import { routes as liveLogsRoutes } from 'features/livelogs'
import { routes as newsAndJournalRoutes } from 'features/news_and_journal'
import { ModalLayer } from 'common/modals/ModalLayer'
import { CollectionListing } from 'features/homepage/Collections/CollectionListing'
import { CollectionsPage } from 'features/homepage/Collections'

// import stuff that doesn't follow the SPA convention
import { EmbedConfiguratorApp } from 'features/embed-configurator'
import { TourismEmbedConfiguratorApp } from 'features/tourism-embed-configurator'
import { EventsEmbedConfigurator } from 'features/configurators/events-embed'
import { FourOhFour } from 'features/pages/FourOhFour'
import { TrialConfirmationPage } from 'features/pages/TrialConfirmationPage'
import { Faq } from 'features/pages/Faq'

// keep google analytics updated on SPA navigation
if (window.ga) {
  browserHistory.listen(function (location) {
    if (!location) { return }
    window.ga('set', 'page', location.pathname + location.search)
    window.ga('send', 'pageview')
  })
}

const shouldUpdateScroll = (prevRouterProps, { location }) => {
  return location.action !== 'REPLACE' &&
    !location.hash.match(/#photos\//) // prevent scroll to top on browserHistory.push in legacy Gallery
}

// This is our routes file, with react-router v3.
// I'm holding off on implementing code splitting until I upgrade to
// react-router v4, which actually makes code splitting based on route
// way less janky. In the mean time, bundle size goes up by about 500k
// which is an alright intermediate tradeoff.
export const Router = () => (
  <ReactRouter history={browserHistory} render={applyRouterMiddleware(useScroll(shouldUpdateScroll))}>
    <Route component={ModalLayer}>
      <Route path='/ride_reports'>
        {rrRoutes}
      </Route>
      <Route path='/reports_pages'>
        {reportsPageRoutes}
      </Route>
      <Route path='/goals'>
        {goalsRoutes}
      </Route>
      {['routes', 'trips'].map((path, idx) =>
        <Route path={`/${path}/:trouteId`} key={idx}>
          {trouteShowRoutes}
        </Route>
      )}
      <Route path='/notifications'>
        {notificationsRoutes}
      </Route>
      <Route path='/styleguide'>
        {styleguideRoutes}
      </Route>
      <Route path='/admin'>
        {adminRoutes}
      </Route>
      <Route path='/iq'>
        {connectIqRoutes}
      </Route>
      <Route path='/organizations'>
        {organizationsRoutes}
      </Route>
      <Route path='/embeds/new' component={EmbedConfiguratorApp} />
      <Route path='/embeds/configure_regional' component={TourismEmbedConfiguratorApp} />
      <Route path='/embeds/configure_events' component={EventsEmbedConfigurator} />
      <Route path='/experiences'>
        {experiencesRoutes}
      </Route>
      <Route path='/users'>
        {usersRoutes}
      </Route>
      <Route path='/'>
        {homepageRoutes}
      </Route>
      <Route path='/collections/:id' component={CollectionListing} />
      <Route path='/users/:user_id/collections' component={CollectionsPage} />
      <Route path='/subscriptions'>
        {paymentsRoutes}
      </Route>
      {/* keeping this around as it lets us collect email from users before they get a trial */}
      {/* <Route path='/start_trial' component={TrialLandingPage} /> */}
      <Route path='/trial_confirmed' component={TrialConfirmationPage} />
      {liveLogsRoutes}
      {newsAndJournalRoutes}
      <Route path='/faq' component={Faq} />
      <Route path='/*' component={FourOhFour} />
    </Route>
  </ReactRouter>
)
